import { render } from "./DataManage.vue?vue&type=template&id=faaefa22&scoped=true"
import script from "./DataManage.vue?vue&type=script&lang=js"
export * from "./DataManage.vue?vue&type=script&lang=js"

import "./DataManage.vue?vue&type=style&index=0&id=faaefa22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faaefa22"]])

export default __exports__